import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-help-delivery',
    templateUrl: './help-delivery.component.html',
    styleUrls: ['./help-delivery.component.css'],
    standalone: false
})
export class HelpDeliveryComponent implements OnInit {

  // images
  @Input() getImgs: string[] = [];
  @Output() showImg: EventEmitter<string> = new EventEmitter<string>();

  constructor() {

  }

  ngOnInit(): void {

  }

  // show selected image on screen
  showImage(url: string): void {
    this.showImg.emit(url);
  }

}
